import {
  DocumentReference,
  ISoftDelete,
  Timestamp,
  WithRef,
} from '@principle-theorem/shared';
import { ApiScope } from '../api-key';
import { IOrganisation } from '../organisation/organisation';
import { IUser } from '../user/user';
import { IPractice } from '../practice/practice';

export interface IPartnerAppOAuth {
  clientId: string;
  clientSecrets: string[];
  redirectUri: string;
  scopes: ApiScope[];
}

export interface IPartnerApp extends ISoftDelete {
  name: string;
  appIconUrl?: string;
  oauth: IPartnerAppOAuth;
}

export enum PartnerAppCollection {
  Webhooks = 'appWebhooks',
  AuthorisationCodes = 'authorisationCodes',
  AccessTokens = 'accessTokens',
}

export interface ITypedAuthorisationCode {
  authorizationCode: string;
  expiresAt: Timestamp;
  redirectUri: string;
  scope?: string[];
  clientRef: DocumentReference<IPartnerApp>;
  userRef: DocumentReference<IUser>;
  codeChallenge?: string;
  codeChallengeMethod?: string;
}

export interface IPartnerAppAuthorisationCode extends ISoftDelete {
  clientId: string;
  userRef: DocumentReference<IUser>;
  organisationRef: DocumentReference<IOrganisation>;
  practiceRefs: DocumentReference<IPractice>[];
  code: string;
  scope: ApiScope[];
  expiresAt: Timestamp;
  metadata: ITypedAuthorisationCode;
}

export interface IPartnerAppAccessToken extends ISoftDelete {
  clientId: string;
  userRef: DocumentReference<IUser>;
  organisationRef: DocumentReference<IOrganisation>;
  practiceRefs: DocumentReference<IPractice>[];
  scope: ApiScope[];
  accessToken: string;
  accessTokenExpiresAt: Timestamp;
  refreshToken?: string;
  refreshTokenExpiresAt: Timestamp;
}

export interface IActivePartnerAppIntegration {
  app: WithRef<IPartnerApp>;
  accessToken: WithRef<IPartnerAppAccessToken>;
}
